/**
 * Created by andreyna on 6/23/2016.
 */
import BaseComponent from '../../base/base_component';
import Model from './external_links_component_model';
import DOM from '../../utils/dom';
import Device from '../../utils/device/device';
import * as EXTERNAL_LINKS_CONSTS from './external_links_consts';
import {PRIORITY_LEVEL} from '../../services/overlay_manager/overlay_manager_levels';
import _ from '../../utils/underscore';
import Event from '../../utils/event';
import {SYSTEM_EVENTS} from '../../events/events';
import {POST_ACTIONS} from '../../events/post_actions';
import * as GNWP_CONSTS from '../../services/gnwp/gnwp_consts';
import {MESSAGE_TYPE} from '../message/message_consts';
import * as OverlayConst from '../overlay/overlay_const';
import {LINK_DEFAULT_CONGIF} from './external_links_consts';


// Views
let view = require('./view/external.html');

/**
 * Open iFrame with specified link
 *
 * Link parameters object should be passed in create method
 *
 * Parameters object structure
 * {
 * source - external link that should be opened in iframe or name of the template in GNWP
 * DEPRECATED payload - if action is POST, then function performs POST request through virtual FORM with specified data in payload parameter
 * integration - iframe POST parameters, used for POST message integration
 * }
 */
class ExternalLinksComponentContoller extends BaseComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ExternalLinksComponentContoller';


    /**
     * @static
     * @type {string}
     */
    static DIRECTIVE = 'cgp-directive-external_link';

    _selector = 'cgp-external-link-component';

    EXTERNAL_LINK_COMMON_CLASS = 'cgp-external-link-frame';

    ADD_CLOSE_OPTION = 'cgp-external-link-close-option';

    /**
     * @property
     * @type {object|null}
     * @private
     */
    _model = null;
    _windowCurrentExecutionEventClick = null;
    /**
     * @param params
     */
    init(params) {
        super.init(params);
        let linkConfig = this._getRegulationExternalLinkConfig();
        this._model = Model.create(Object.assign({}, params, {linkConfig: linkConfig}));
    }


    /**
     *
     */
    start() {
        return this._openLink();
    }


    _getRegulationExternalLinkConfig() {
        let regulationConfig = this.serviceFactory.regulationService().getRegulation().getExternalLinksConfig();
        return regulationConfig ? _.mergeDeep({}, LINK_DEFAULT_CONGIF, regulationConfig) : LINK_DEFAULT_CONGIF;
    }

    /**
     *
     * @private
     */
    _openLink() {
        return this.serviceFactory.regulationService().runConditionsBeforeOpenLink(this._model.getSource()).then(() => {
            this.logger.debug('Opening source ' + this._model.getSource() + ' or link ' + this._model.getSourceLink());
            let oAuth2Service = this.serviceFactory.oAuth2Service();
            // check whether user has to be authorized before external link execution
            if (this._model.getIsForceAuth() && !oAuth2Service.isAuthorized()) {
                this._forceAuth();
                return;
            }

            if (this._model.getIsNotAuthRequired() && oAuth2Service.isAuthorized()) {
                this.logger.warn('Opening ' + this._model.getSource() + ' is not allowed when user is authorized');
                return;
            }

            let targetView = this._model.getCallbackUrl() ? this._model.getCallbackView() : this._model.getTargetView();

            // We need it so the browser not block it as popup(happen when do it inside callback)
            const openInNewWindowHook = this.serviceFactory.integrationService().openInNewWindowHook();
            if (!Device.hybrid.inCasino && !openInNewWindowHook && targetView === EXTERNAL_LINKS_CONSTS.NAVIGATION_VIEWS.WINDOW) {
                this._windowCurrentExecutionEventClick = this.serviceFactory.windowService().openInNewWindow('about:blank');
            }

            return this._getLinkURL(targetView).then((linkURLObject) => {
                switch (targetView) {
                    case EXTERNAL_LINKS_CONSTS.NAVIGATION_VIEWS.IFRAME:
                        this._openInIframe(linkURLObject.linkURL, linkURLObject.gnwpResponse);
                        break;
                    case EXTERNAL_LINKS_CONSTS.NAVIGATION_VIEWS.SECOND_WEB_VIEW:
                        this._openInSecondWebView(linkURLObject.linkURL);
                        break;
                    default: //open in new window
                        this._openInWindow(targetView, linkURLObject.linkURL);
                        break;
                }
                return linkURLObject;
            }).catch((err) => {
                this.logger.error("Failed to got valid URL. Error: ", err, " ,value: ", targetView);
            });
        });
    }


    /**
     * Open authentication dialog and perform link navigation only after successful login
     *
     * @private
     */
    _forceAuth() {
        this.onSystemEvent(SYSTEM_EVENTS.OAUTH_STATE_CHANGE, () => {
            this._detachSystemEvents();
            this._openLink();
        });


        // if instead of perform login user opens registration or closes login form, we should terminate waiting for OAUTH state change
        this.onSystemEvent(SYSTEM_EVENTS.LOGIN_FORM_CLOSE, () => {
            // componentGlobalEvents used as lock for concurrency. After Successful login OAUTH_STATE_CHANGE fired first and remove
            // SYSTEM_EVENTS.LOGIN_FORM_CLOSE event registration, so bellow flow can not be running and vice versa
            // If we access this code, login window was closed without login
            this._detachSystemEvents();
            this._onClose(POST_ACTIONS.TERMINATE, true);
        });

        this.serviceFactory.webLoginService().openLoginForm();
    }


    /**
     * Execute GNWP request and
     *
     * @private
     */
    _executeFrameGNWP(gnwpResponse) {
        this.openOverlay();
        this.logger.debug('GNWP response received. Start GNWP navigation');
        gnwpResponse.performGNWPNavigation(GNWP_CONSTS.REQUEST_METHODS.POST, GNWP_CONSTS.TARGET_VIEWS.IFRAME, this._model.getFrameName());
        this._subscribePostMsg();
        this._getHandlerByConfig().display();
    }


    /**
     * Open link in iframe. If it is a GNWP source, performs POST request to iframe within GNWP parameters
     * @private
     */

    _openInIframe(linkURL, gnwpResponse) {

        Event.fire(SYSTEM_EVENTS.SECOND_WEB_VIEW_CLOSE_ALL);

        let bakedHTML = this.bake(view);
        this.setHTML(bakedHTML);
        let frame = this.getEl().querySelector(".cgp-external-link-container");
        frame.allow = Device.browser.getIframeAllowAttributeValue();
        frame.allowFullscreen = true;

        if (!gnwpResponse) {
            this.openOverlay();

            this._subscribePostMsg();
            if (this._model.getLinkConfig()[this._model.getConfigKey()].immediateShow === true) {
                this._getHandlerByConfig().display();
            }

            frame.src = linkURL + _.jsonToQueryString(this._model.getOptions());


            DOM.addClass(this.getEl(), this._model.getFrameLinkClass());
            return;
        }

        this._executeFrameGNWP(gnwpResponse);
    }



    /**
     * Create Exception with list of gnwp valid sources
     *
     * @param params
     * @returns {*}
     * @private
     */
    _getError() {
        let gnwpSources = [];
        let message = 'Source ' + this._model.getSourceLink() + ' is not found in GNWP links and is not valid http URL';
        Object.keys(EXTERNAL_LINKS_CONSTS.GNWP_SOURCES).forEach((key) => {
            gnwpSources.push(EXTERNAL_LINKS_CONSTS.GNWP_SOURCES[key]);
        });

        return {error: message, GNWPSources: gnwpSources};
    }


    /**
     * Open overlay for iframe
     *
     */
    openOverlay() {
        if (this._model.getType() === EXTERNAL_LINKS_CONSTS.COMPONENT_TYPES.API) {
            let additionalClasses = [this._model.linkClass, this.EXTERNAL_LINK_COMMON_CLASS];

            if (this._model.getAddCloseOption()) {
                additionalClasses.push(this.ADD_CLOSE_OPTION);
            }
            if (this._model.getLinkConfig()[this._model.getConfigKey()].immediateShow === false) {
                additionalClasses.push('cgp-overlay-hide');
            }

            Event.fire(SYSTEM_EVENTS.OPEN_OVERLAY, {
                component: this,
                id: this._model.getComponentId(),
                // el: component.getEl(),
                additionalClasses: additionalClasses,
                priority: this._model.getPriorityLevel(),
                contentAdditionalClasses: this._model.getLinkConfig()[this._model.getConfigKey()].isMobileFullScreen === false ? ['cgp-mobile-no-full-screen-overlay'] : [],
                // contentAdditionalClasses: EXTERNAL_LINKS_CONSTS.LINK_DEFAULT_CONGIF[this._model.getConfigKey()].isCloseBtnAllowed !== false ? ['cgp-themes-lb-stroke'] : null,
                // Close strip cause the height problem, that class 'cgp-external-link-closable' fixes it.
                isCloseBtnAllowed: this._model.getForceHideCloseButton() ? false : this._model.getLinkConfig()[this._model.getConfigKey()].isCloseBtnAllowed,
                awaitForDisplay: !this._model.getLinkConfig()[this._model.getConfigKey()].immediateShow,
                btnCloseCallback: () => {
                    Event.fire(SYSTEM_EVENTS.DETACH_REGISTER_EVENT);
                    this._getHandlerByConfig().onBtnCloseClicked();
                },
                closeCallback: (postAction) => {
                    this._onClose(postAction, true);
                }
            });
        }

        return this;
    }


    closeExpiredOverlay() {
        Event.fire(SYSTEM_EVENTS.OVERLAY_CLOSE_EXPIRED, this._model.getComponentId());
    }

    openAwaitOverlay() {
        Event.fire(SYSTEM_EVENTS.OVERLAY_OPEN_AWAIT, this._model.getComponentId());
    }


    /**
     * is ExternalPage
     *
     * @private
     */
    isExternalPage() {
        let key = this._model.getConfigKey();

        if (('sport' === key || 'poker' === key) && Device.hybrid.isEmbedded) {// Sport/Poker/Cashier should be opened inside of the same application in HybridEmbedded
            return false;
        }

        if (('sport' === key || 'poker' === key  || 'cashier' === key) && (Device.hybrid.inCasino || Device.hybrid.isEmbedded)) {
            return true;
        }

        return false;
    }

    /**
     * Get link URL. if callback URL exists return him, if not and gnwp tempalte return the gnwp answer and if not the source url.
     * @param target
     * @private
     */
    _getLinkURL(target) {
        return this._getCallbackURL().then((linkURL)=> {
            return this._createLinkURLObject(linkURL);
        }).catch(()=> {
            let sourceLink = this._model.getSourceLink();
            if(!sourceLink) {
                return this.getGNWPUrl(target).then((gnwpURL)=> {
                    return this._createLinkURLObject(gnwpURL.linkURL, gnwpURL.gnwpResponse);
                });
            } else if(sourceLink){
                return Promise.resolve(this._createLinkURLObject(this._getSourceURL()));
            } else {
                this.logger.error('Failed to get link because do not have source link and this is not gnwp template, sourceLink value: ', sourceLink);
                return Promise.reject();
            }
        });
    }


    _createLinkURLObject(linkURL, gnwpResponse=null) {
        return {
            gnwpResponse: gnwpResponse,
            linkURL: linkURL
        }
    }

    /**
     * get link url for callback.
     * @returns {Promise.<*>|Promise<R>|Promise<T>}
     * @private
     */
    _getCallbackURL() {
        let callbackUrl = this._model.getCallbackUrl();
        if (callbackUrl) {
            if (!this.serviceFactory.oAuth2Service().isAuthorized()) { // TODO maybe we don't need an authorization check
                this.logger.error('Callback url is provided, but user is not authorized!  => ', callbackUrl);
                return Promise.reject();
            }
            // renew token
            this.logger.debug('Renew token for => ', callbackUrl);
            return this.serviceFactory.userService().renewLoginToken()
                .then(tokenObj => {
                    let url = callbackUrl + '?UserInfo=' + tokenObj.token;
                    this.logger.debug('Getting callback url => ', url);
                    return url;
                });
        }

        return Promise.reject();
    }

    /**
     * Get source URL
     * @private
     */
    _getSourceURL() {
        if (!_.isValidUrl(this._model.getSourceLink())) {
            this.logger.error(this._getError());
            if(this._windowCurrentExecutionEventClick) {
                this._windowCurrentExecutionEventClick.close();
                this._windowCurrentExecutionEventClick = null;
            }

            // Invalid URL - return empty string.
            return "";
        }
        return this._model.getSourceLink();
    }

    /**
     * Open link in second web view.
     * @private
     */
    _openInSecondWebView(url) {
        Event.fire(SYSTEM_EVENTS.SECOND_WEB_VIEW_NAVIGATE_SPORT, url);
    }

    /**
     * Open link in new window (browser tab) or redirect.  GNWP is opened through GET request
     *
     * @private
     */
    _openInWindow(targetView, linkURL) {
        if (this._model.getType() === EXTERNAL_LINKS_CONSTS.COMPONENT_TYPES.DIRECTIVE) {
            throw new Error("Open external link in new window through directive not supported!!!")
        }

        if (this.isExternalPage()) {
            this.logger.debug('Opening a new window tab in Hybrid for link: ', linkURL);
            this.serviceFactory.hybridService().openExternalLink(linkURL);
        } else {
            if (targetView === EXTERNAL_LINKS_CONSTS.NAVIGATION_VIEWS.REDIRECT) {
                this.logger.debug('Redirecting to => ', linkURL);
                this.serviceFactory.windowService().redirect(linkURL);
            } else {
                this.logger.debug('Opening a new window tab for link: ', linkURL);
                this._windowCurrentExecutionEventClick ? this._windowCurrentExecutionEventClick.location = linkURL :
                    this.serviceFactory.windowService().openInNewWindow(linkURL);
            }
        }
    }

    getGNWPUrl(target) {
        return this._gnwpService().getGNWPResponse(this._getGNWPRequestParams(this._getGNWPTarget(target)))
            .then((GNWPResponse) => {
                if (!GNWPResponse) {
                    this.logger.error('GNWP Response invalid => ', GNWPResponse);
                    return;
                }

                let gnwpURL = GNWPResponse.getGNWPUrl();
                this.logger.debug('Getting gnwp url => ', gnwpURL);

                return {
                    gnwpResponse: GNWPResponse,
                    linkURL: gnwpURL
                };
            })
    }

    /**
     * return gnwp target according to target.
     * @private
     */
    _getGNWPTarget(target) {
        return  target === EXTERNAL_LINKS_CONSTS.NAVIGATION_VIEWS.IFRAME? GNWP_CONSTS.TARGET_VIEWS.IFRAME : GNWP_CONSTS.TARGET_VIEWS.WINDOW;
    }

    /**
     * Close component and free all resources
     * @private
     */
    _onErrorHandler(reason) {
        Event.fire(SYSTEM_EVENTS.CLOSE_OVERLAY, {priority: PRIORITY_LEVEL.POP_UP});
        this.closeLink();
        Event.fire(SYSTEM_EVENTS.MESSAGE_OPEN, {type: MESSAGE_TYPE.ERROR, text: this.serviceFactory.regulationService().getErrorMessage(reason.error_code)});
    }


    /**
     * Prepare parameters to GNWP request
     *
     * @returns {object} GNWPRequest
     * @private
     */
    _getGNWPRequestParams(target) {
        let GNWPRequest = Object.assign({templateName: this._model.getSource()}, this._model.getOptions(), {target: target});

        return GNWPRequest;
    }


    /**
     * Find and return instance of the handler for current external link source
     *
     * @returns {undefined}
     * @private
     */
    _getHandlerByConfig() {
        let handler = this._model.getHandlers().find(h => h.default.HandlerName === this._model.getConfigKey());
        return handler ? handler.default.create({component : this}) : undefined;
    }

    /**
     * Handle post message from membership and perform specific actions
     * @param data
     * @private
     */
    _postMessageHandler(postMessage) {
        if (_.isNullOrUndefined(postMessage)) {
            return;
        }

        if (this.getTargetFrame().contentWindow !== postMessage.source) {
            this.logger.debug('Post Message source does not match the iframe content');
            return;
        }
        this.logger.debug(`Post message event received. Message data : [${JSON.stringify(postMessage.data)}]`);
        let postData = _.isObject(postMessage.data) ? postMessage.data : _.safeJSON(postMessage.data);

        this.logger.debug('Post message has been parsed successfully. PostData = [' + JSON.stringify(postData) + ']');

        let handler = this._getHandlerByConfig();

        if (handler) {
            handler.handlePostMessage(postData);
        } else {
            this.logger.error('Handler for ' + this._model.getSource() + ' was not found.');
        }
    }


    /**
     * add specific attr to iframe
     * @private
     */
    addAttrToIframe(attrName,value) {
        let el = this.getEl();
        let frame = el.getElementsByTagName("iframe")[0];
        frame.setAttribute(attrName, value);

        return this;
    }


    /**
     * Show iframe and hide loading div
     */
    display() {
        let el = this.getEl();
        let frame = el.getElementsByTagName("iframe")[0];
        DOM.hide(this.getDOMElementByClassName('cgp-loader cgp-external-link-loader'));
        DOM.removeClass(frame, 'cgp-external-link-hide');
        let overlayEl = this.getComponentOverlayEl();
        if (overlayEl) {
             overlayEl.classList.remove("cgp-overlay-hide");
        }
        if (false === this._model.getLinkConfig()[this._model.getConfigKey()].immediateShow) {
            this.openAwaitOverlay();
        }

        Event.fire(SYSTEM_EVENTS.EXTERNAL_LINK_OPENED, this._model.getConfigKey());
        return this;
    }


    /**
     * Set the overlay size
     *@param (dimensions)
     */
    setSize(dimensions){
        this.logger.debug(['setSize called on ExternalLinks', dimensions]);

        //if client is mobile, width & height will be -1 so we dont need to change content overlay dimensions
        if (dimensions.width && dimensions.height && -1 !== dimensions.width) {
            let overlayContentEl = this.getComponentContentOverlayEl();
            DOM.addStyle(overlayContentEl,'width',dimensions.width + 'px');
            DOM.addStyle(overlayContentEl,'height',dimensions.height + 'px');
        }

        return this;
    }


    /**
     * Get component overlay el
     */
    getComponentContentOverlayEl() {
        let overlayEl = this.getComponentOverlayEl();
        if (overlayEl) {
            return overlayEl.getElementsByClassName(OverlayConst.OVERLAY_CONTENT_PROPERTIES.CLASS_NAME)[0];
        }
    }

    getComponentOverlayEl() {
        return DOM.$$('#cgp_overlay' + this._model.getComponentId());
    }


    /**
     * Hide loading dialog when frame loading failed
     *
     * @private
     */
    _onClose(postAction = POST_ACTIONS.CLOSE, avoidCloseOverlay = false) {
        if (avoidCloseOverlay === false) {
            Event.fire(SYSTEM_EVENTS.CLOSE_OVERLAY, {
                el: this.getEl(),
                priority: this._model.getPriorityLevel(),
                closeParams: postAction
            });
        } else {
            Event.fire(SYSTEM_EVENTS.EXTERNAL_LINK_CLOSED, this._model.getConfigKey());
            this.performCallback(postAction);
        }
    }


    /**
     * Perform actionCallback only once
     * @param actionName
     */
    performCallback(actionName) {
        this.logger.debug('Perform callback with actionName = ' + actionName);
        if (!actionName) {
            return;
        }
        let callback = this._model.getActionCallback();
        if (_.isFunction(callback)) {
            callback.call(null, {source: this._model.getConfigKey(), actionName: actionName});
            callback = null;
        }
    }


    /**
     * Get indication whether posat action call back exists
     */
    getIsHasActionCallback() {
        let callback = this._model.getActionCallback();
        return _.isFunction(callback);
    }


    /**
     * Subscribe to post message arrive
     *
     * @private
     */
    _subscribePostMsg() {
        this.onSystemEvent(SYSTEM_EVENTS.POST_MESSAGE_ARRIVE, data => {
            this._postMessageHandler(data);
        }, this);
    }


    /**
     * Open specified link on overlay or new window
     * @usage
     * In API:  ExternalLinksController.create({source:'my_account'}).openLink();
     *
     */
    openLink() {
        return this.start();
    }


    /**
     * Close overlay with iframe
     * Destroy overlay
     */
    closeLink(postAction) {
        this._onClose(postAction);
    }

    getTargetView() {
        return this._model.getTargetView();
    }

    getTargetFrame() {
        return this.getEl().getElementsByTagName("iframe")[0];
    }

    _gnwpService() {
        return this.serviceFactory.gnwpService();
    }
}

export default ExternalLinksComponentContoller;
